import { Amount } from 'src_common/common/amount/Amount';
import { CurrencySymbolType } from 'src_common/common/amount/website-money/currency';
import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

export const validateMinAmount =
    (minValue: (() => Amount) | Amount, currencySymbol: () => CurrencySymbolType, errorMessage: String) =>
    (amount: Amount): Result<Amount> => {
        const sybmol = currencySymbol();
        const parsedMinAmount = minValue instanceof Amount ? minValue : minValue();
        if (amount.isLessThan(parsedMinAmount)) {
            return Result.createError(
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `${errorMessage} ${sybmol}${parsedMinAmount.value}`
            );
        }

        return Result.createOk(amount);
    };

export const validateMaxAmount =
    (maxValueFunction: () => Amount, currencySymbol: () => CurrencySymbolType, errorMessage: String) =>
    (amount: Amount): Result<Amount> => {
        const maxValue = maxValueFunction();
        const sybmol = currencySymbol();

        if (amount.isGreaterThan(maxValue)) {
            return Result.createError(
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `${errorMessage} ${sybmol}${maxValue.value}`
            );
        }

        return Result.createOk(amount);
    };
